import { createClient } from 'contentful';
import { CONTENTFUL } from '../constants/constants';

export function getContentfulClient() {
  return createClient({
    space: CONTENTFUL.SPACE_ID,
    accessToken: CONTENTFUL.ACCESS_TOKEN,
    environment: CONTENTFUL.ENVIRONMENT,
  }).withoutUnresolvableLinks;
}
